// Results of a control or security measure task (US 9478), stored in project_tasks.completion_status.
// They replaced pass and fail; values saved before are read as Completed and Deviations.
export const CONTROL_RESULTS = [
  { value: 'completed', icon: 'check-circle', tone: 'teal', cls: 'icon-success' },
  { value: 'deviations', icon: 'exclamation-triangle', tone: 'amber', cls: 'risk-6' },
  { value: 'not_performed', icon: 'times-circle', tone: 'red', cls: 'icon-danger' },
  { value: 'not_applicable', icon: 'minus-circle', tone: 'grey', cls: 'text-muted' }
];

const LEGACY = { pass: 'completed', fail: 'deviations' };

// The result for a stored value, or null when the task has none
export function controlResult(value) {
  const key = LEGACY[value] || value;
  return CONTROL_RESULTS.find(result => result.value === key) || null;
}

// The results as options for the task: {name, value, icon, tone}
export function controlResultOptions($t) {
  return CONTROL_RESULTS.map(result => Object.assign({ name: $t('tasks.control_result.' + result.value) }, result));
}
